import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutube, faTwitter, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function FooterOne() {
  // Social media links data
  const socialMediaLinks = [
    { id: 1, href: "https://www.youtube.com/@gvkEDU", icon: faYoutube, name: "YouTube" },
    { id: 2, href: "https://x.com/gvkedu", icon: faTwitter, name: "Twitter" },
    { id: 3, href: "https://www.linkedin.com/company/gvkedu", icon: faLinkedin, name: "LinkedIn" },
    { id: 4, href: "https://www.instagram.com/gvk_edu/", icon: faInstagram, name: "Instagram" },
    { id: 5, href: "mailto:info@gvkedu.com", icon: faEnvelope, name: "Email" },
    { id: 6, href: "https://wa.me/9985565894", icon: faWhatsapp, name: "WhatsApp" },
  ];

  return (
    <>
      <style>{`
        .footer-compact {
          padding: 20px 0 !important;
        }
        .footer-compact .footer-header {
          padding: 0 !important;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
          padding-bottom: 15px !important;
        }
        .footer-compact .footer-footer {
          padding: 15px 0 0 0 !important;
          border-top: none !important;
        }
        @media (max-width: 767px) {
          .footer-header-socials__list {
            justify-content: space-between !important;
            gap: 0 !important;
          }
          .footer-header-socials-col {
            width: 100% !important;
          }
          .footer-compact .footer-footer {
            padding-top: 20px !important;
          }
        }
        @media (min-width: 768px) {
          .footer-header-socials__list {
            justify-content: flex-start !important;
            gap: 15px !important;
          }
          .footer-header-socials-col {
            width: auto !important;
          }
        }
      `}</style>
      <footer 
        className="footer -type-1 bg-black -green-links footer-compact"
        style={{
          position: 'relative',
          zIndex: 10,
          width: '100%'
        }}
      >
        <div className="container">
          <div className="footer-header">
            <div className="row justify-between items-center">
              <div className="col-auto footer-header-socials-col">
                <div className="footer-header-socials">
                  <div className="footer-header-socials__title text-white text-17 fw-500 mb-15 md:d-none">
                    Follow us on social media
                  </div>
                  <div 
                    className="footer-header-socials__list d-flex items-center"
                    style={{
                      width: '100%'
                    }}
                  >
                  {socialMediaLinks.map((link) => {
                    const isEmail = link.href.startsWith('mailto:');
                    
                    return (
                      <a
                        key={link.id}
                        className="size-40 d-flex justify-center items-center text-white hover-opacity-80"
                        href={link.href}
                        {...(isEmail ? {} : { target: "_blank", rel: "noopener noreferrer" })}
                        aria-label={link.name}
                        title={link.name}
                        style={{ 
                          width: '40px', 
                          height: '40px', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          color: '#ffffff',
                          fontSize: '20px',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                          borderRadius: '50%',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <FontAwesomeIcon 
                          icon={link.icon} 
                          size="lg"
                          style={{ 
                            color: '#ffffff',
                            display: 'block'
                          }} 
                        />
                      </a>
                    );
                  })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-footer">
            <div className="row y-gap-10 justify-between items-center">
              <div className="col-auto">
                <div className="footer-footer__copyright text-white text-14">
                  © {new Date().getFullYear()} gvkEDU. All Right Reserved.
                </div>
              </div>
              <div className="col-auto">
                <div className="footer-footer__list d-flex items-center y-gap-10 x-gap-20">
                  <Link 
                    to="/support" 
                    className="text-white text-14 hover-opacity-80"
                    style={{ textDecoration: 'none' }}
                  >
                    Support
                  </Link>
                  <Link 
                    to="/privacy-policy" 
                    className="text-white text-14 hover-opacity-80"
                    style={{ textDecoration: 'none' }}
                  >
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
